<div class="pending-deletion-popup">
  <div class="popup-header">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      alt="back"
      class="back-btn pointer-cursor"
      (click)="goBack()"
    />
    <div class="header-center">
      <span class="header-name">{{ userName }}</span>
      <span class="header-title">{{ "USER_PROFILE" | translate }}</span>
    </div>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      alt="close"
      class="close-btn pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div class="popup-body">
    <h2 class="section-title">
      {{ "PENDING_ACCOUNT_DELETION_TITLE" | translate }}
    </h2>

    <p class="section-desc">
      {{ "PENDING_ACCOUNT_DELETION_DESC" | translate }}
      <strong>{{ formattedDate }}</strong
      >.
    </p>

    <p class="action-heading">{{ "CHOOSE_AN_ACTION" | translate }}</p>

    <ul class="action-options">
      <li>
        <strong>{{ "REMOVE_USER_LABEL" | translate }}:</strong>
        {{ "REMOVE_USER_DESC" | translate }}
      </li>
      <li>
        <strong>{{ "REJECT_DELETION_LABEL" | translate }}:</strong>
        {{ "REJECT_DELETION_DESC" | translate }}
      </li>
    </ul>
  </div>

  <div class="popup-footer">
    <button class="btn-remove" (click)="onRemoveUser()">
      {{ "REMOVE_USER_BTN" | translate }}
    </button>
    <button class="btn-reject" (click)="onRejectDeletion()">
      {{ "REJECT_DELETION_BTN" | translate }}
    </button>
  </div>
</div>
